import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';
import NotiMessage from '../../services/NotiMessage';

const notiMessage = new NotiMessage('success');

// URL //
const eachUrl = 'region/getEach?';
const allUrl = 'region/get?';
const storeUrl = 'region/store';
const updateUrl = 'region/update?';
const deleteUrl = 'region/delete?';

const state = {
  regions: [],
  region: {},
};
const getters = {};
const mutations = {
  SET_REGIONS(state, payload) {
    state.regions = payload.data.data
  },
  SET_REGION(state, payload) {
    state.region = payload.data.data
  },
  ADD_REGION(state, payload) {
    state.regions.push(payload.data.data)
  },
  REMOVE_REGION(state, payload) {
    const regions = state.regions.filter((region) => region.id != payload.id)
    state.regions = [...regions]
  }
};

const actions = {
  async getRegions({ commit }) {
    const response = await Request.get_data(allUrl)
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_REGIONS", response);
  },
  async getRegion({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_REGION", response);
  },
  async createRegion({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_REGION", response);
      notiMessage.displayNotiMsg('Saved Success')
      return true
    }
    return false;
  },
  async updateRegion(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg('Updated Success')
      return true
    }
    return false;
  },
  async deleteRegion({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_REGION", payload);
      notiMessage.displayNotiMsg('Deleted Success')
      return true
    }
    return false;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
